import { useEffect, useState } from "react";
import axios from "axios";

// Toggle luồng mua TikTok: 'showcase' (trưng bày cũ) | 'link' (mua qua link RioHub).
// Đọc file tĩnh /img/tiktok-affiliate-config.json (giống guide-videos.json bên web).
// CHỈ dùng {mode, enabled}; creator/channel có trong file nhưng bỏ qua (api key chỉ env).
const CONFIG_URL = `${process.env.REACT_APP_API_PUBLIC_URL || ""}/img/tiktok-affiliate-config.json`;

/** @returns {{ isLinkMode: boolean, enabled: boolean, loading: boolean }} */
export default function useTikTokShoppingMode() {
    const [state, setState] = useState({ isLinkMode: false, enabled: false, loading: true });

    useEffect(() => {
        let active = true;
        (async () => {
            try {
                // Chỉ dùng ?t= để cache-bust. KHÔNG set header Cache-Control:
                // header tuỳ chỉnh → browser bắt preflight OPTIONS, mà /img/ static
                // trả 405 → fetch fail → fallback showcase nhầm. GET đơn giản = không preflight.
                const { data } = await axios.get(CONFIG_URL, {
                    params: { t: Date.now() },
                    timeout: 8000,
                });
                if (!active) return;
                const enabled = data?.enabled === true;
                const isLinkMode = data?.mode === "link" && enabled;
                setState({ isLinkMode, enabled, loading: false });
            } catch {
                if (active) setState({ isLinkMode: false, enabled: false, loading: false });
            }
        })();
        return () => {
            active = false;
        };
    }, []);

    return state;
}
